import React from 'react'

export default function NotFoundPage() {
    return (
        <div className='landingPage'>
            <h2 className='text-white'>404 Not Found Page</h2>
        </div>
    )
}
